import { render, staticRenderFns } from "./addCommentPop.vue?vue&type=template&id=022b0be4"
import script from "./addCommentPop.vue?vue&type=script&lang=js"
export * from "./addCommentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports